<template>
  <Breadcrumbs
    :breadcrumbs="breadcrumbList"
    :is-category-link="true"
    data-testid="categoryBreadcrumbs"
  />
</template>

<script lang="ts">

import type { Breadcrumb } from '~~/types/components/Breadcrumbs/Breadcrumb';

import { prepareBreadcrumb } from '~~/helpers/prepareBreadcrumb/prepareBreadcrumb';
import { getCategoryPath } from '~~/helpers/category/getCategoryPath';

export default defineComponent({
  name: 'CategoryBreadcrumbs',

  setup() {

    const { activeCategories } = useCategories();
    const { categoryTree } = useCategoryTree();

    const breadcrumbList: ComputedRef<Breadcrumb[]> = computed(() =>
      activeCategories.value?.slice()
        .map(
          (category, index) => (prepareBreadcrumb(
            category?.name || '',
            getCategoryPath(category?.slug, categoryTree.value) || '',
            index,
          ))),
    );

    return {
      breadcrumbList,
    };
  
  },
});


</script>
